(ns app.front.view.complaint.dashboard
  (:require [app.domain.complaint.model :as complaint-model]
            [app.domain.property.model :as property-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.municipality :as municipality]
            [app.front.ui :as ui]
            [app.front.ui.combo-box :as ui-combo]
            [app.front.ui.select :as ui-select]
            [app.front.ui.updated :as ui-updated]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.complaint.add-form :as complaint-form]
            [app.front.view.complaint.detail-view :as complaint-detail-view]
            [app.front.view.complaint.new-case-view :as new-case-view]
            [app.front.view.complaint.search :as complaint-search]
            [app.front.view.complaint.subs :as complaint-subs]
            [app.front.view.complaint.util :as complaint-util]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.map-common.info-box :as map-common-info-box]
            [app.front.view.map-common.util :as map-common-util]
            [app.front.view.property.subs :as property-subs]
            [app.front.view.workspace.map :as workspace-map]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [schema-tools.core :as st]
            [schema.core :as s]))


(defn on-cancel-click []
  (>evt [::complaint-subs/select-property nil])
  (>evt [::complaint-form/clear-data])
  (>evt [::complaint-subs/toggle-adding-complaints-to-case false])
  (>evt [::complaint-subs/clear-added-complaints])
  (>evt [::complaint-subs/clear-location])
  (>evt [::complaint-subs/close-complaint-view]))


(defn new-complaint-form
  [{:keys [tr lang selected-property selected-group location on-close coordinates on-success-evt header]}]
  (let [on-cancel-click       (or on-close on-cancel-click)
        dashboard-coordinates (<sub [::complaint-subs/new-complaint-coordinates])]
    [map-common-info-box/right-side-box (util/mmap on-cancel-click tr)
     header
     [complaint-form/form (util/mmap {:authority-groups    (:authority-groups selected-group)
                                      :municipality-number (:municipality/number selected-group)
                                      :coordinates         (or coordinates dashboard-coordinates)
                                      :on-success-evt      (or on-success-evt
                                                               ::complaint-subs/submit-new-complaint.success)
                                      :command             :complaint/create-complaint
                                      :source-selectable?  true}
                                     tr lang selected-property location on-cancel-click)]]))


(defn go-to-case-button [case-workspace-id tr opts]
  (when case-workspace-id
    (cc/button (merge {:size :small
                       :kind :primary
                       :href (href/href :view/workspace {:workspace-id case-workspace-id})}
                      opts)
               (tr [:complaint/go-to-case]))))


(defn case-creation-action-visible? [allow-actions? state-open? case-workspace-id]
  (and allow-actions?
       state-open?
       (not case-workspace-id)))


(defn complaint-view-content
  [{:keys [complaint action-events allow-actions? case-workspace-id detail-class-name]
    :or   {allow-actions?    true
           detail-class-name "px-2 pb-2"}
    :as   props}]
  (let [state-open?         (du/in-state? :complaint.state/open complaint)
        selected-property   (get props :selected-property (<sub [::complaint-subs/selected-property]))
        permit-type         (complaint-model/complaint-permit-type complaint)
        tr                  (<sub [::property-subs/tr-for-permit-type permit-type])
        complaint-photo-ids (<sub [::complaint-subs/complaint-photo-ids (:db/id complaint)])]
    [:<>
     [:div.flex-grow.min-h-0.overflow-y-auto
      {:class detail-class-name}
      [complaint-detail-view/complaint-content (assoc props :tr tr)]]
     [:div.flex.justify-end.flex-wrap
      [:div.flex.flex-wrap
       (when (and allow-actions?
                  ((du/in-state-fn :complaint.state/open :complaint.state/abandoned) complaint)
                  (complaint-util/can-edit-complaint? complaint))
         (cc/button {:size     :small
                     :kind     :tertiary
                     :on-click #(>evt [::complaint-subs/update-complaint
                                       (:complaint/id complaint)
                                       {:domain/state (if state-open?
                                                        :complaint.state/abandoned
                                                        :complaint.state/open)}
                                       (complaint-subs/mutation-options action-events)])}
                    (tr [(if state-open?
                           :code-enforcement/abandon-complaint
                           :code-enforcement/reopen-complaint)])))
       (when (and (case-creation-action-visible? allow-actions? state-open? case-workspace-id)
                  (<sub [::complaint-subs/write-auth-permit-type? permit-type]))
         (cc/button {:size       :small
                     :class-name "ml-2"
                     :on-click   #(do (>evt [::new-case-view/save-complaint-for-case-creation complaint])
                                      (>evt [::new-case-view/set-new-case-property selected-property])
                                      (>evt [::new-case-view/select-all-complaint-photos complaint-photo-ids])
                                      (>evt [::complaint-subs/set-permit-type-for-case-creation permit-type])
                                      (>evt [::new-case-view/open-create-modal (:cleanup-event action-events)]))}
                    (tr [:code-enforcement/open-case-creation])))
       (go-to-case-button case-workspace-id tr {:class-name "ml-2"})]]]))


(defn complaint-view [{:keys [tr lang complaint-id selected-property]}]
  (let [loading?  (<sub [::complaint-subs/complaint-view-loading?])
        complaint (<sub [::entities/entity {:complaint/id complaint-id}])]
    [map-common-info-box/right-side-box
     (util/mmap {:on-back-click (when selected-property
                                  #(>evt [::complaint-subs/close-complaint-view]))}
                on-cancel-click tr)
     [complaint-view-content (util/mmap lang complaint loading?)]]))

(defn permit-type-group-id [selected-group permit-type]
  (-> selected-group
      :authority-groups
      (p/find-first {:permit-type permit-type})
      :group/id))

(defn create-case-button [{:keys [selected-group selected-property location case-cleanup-event]}
                          permit-type case-complaints btn-text]
  (let [accepted-group (-> case-complaints first :group/id)]
    [:div.flex.w-1-2.px-1
     (cc/button {:size       :small
                 :kind       :primary
                 :class-name "w-full"
                 :disabled   (boolean (and (some? accepted-group)
                                           (not= accepted-group
                                                 (permit-type-group-id selected-group permit-type))))
                 :on-click   #(do (when (not-empty case-complaints)
                                    (doseq [complaint case-complaints]
                                      (>evt [::new-case-view/get-complaint-for-case-creation
                                             (:complaint/id complaint)])))
                                  (>evt [::new-case-view/set-new-case-property selected-property])
                                  (>evt [::new-case-view/set-new-case-location location])
                                  (>evt [::complaint-subs/set-permit-type-for-case-creation permit-type])
                                  (>evt [::new-case-view/open-create-modal case-cleanup-event]))}
                btn-text)]))

(defn selected-property-view
  [{:keys [tr lang selected-property location on-close header] :as props}]
  (let [complaints      (get props
                             :complaints
                             (<sub [::complaint-subs/property-complaints
                                    (-> selected-property :property :property/id)]))
        on-cancel-click (or on-close on-cancel-click)
        address         (-> selected-property :address :address/full-address)
        case-complaints (<sub [::complaint-subs/complaints-to-case])
        accepted-group  (-> case-complaints first :group/id)]
    [map-common-info-box/right-side-box (util/mmap on-cancel-click tr)
     header
     [:div.flex-grow.overflow-y-auto.px-2.pb-2
      [:h3.font-bold.text-lg.mb-2 (or address (complaint-form/location-address location tr))]
      (for-frag [complaint complaints
                 :let [permit-type (:permit-type complaint)
                       tr          (<sub [::complaint-subs/complaint-tr permit-type])
                       write-auth? (<sub [::complaint-subs/write-auth-permit-type? permit-type])]]
        [:div.flex.flex-row.bg-white.rounded.mt-2
         [:div.flex {:class [(if write-auth? "w-2-3" "w-full")]}
          [:button.p-3.bg-white.font-bold.w-full.border-0.text-left.select-search-result-button.w-full
           {:on-click #(>evt [::complaint-subs/open-complaint-view (:complaint/id complaint)])}
           (-> complaint :complaint/category-names (i18n-model/get-text-from-entities-or-map lang))]]
         (when (and (du/in-state? :complaint.state/open complaint)
                    write-auth?)
           [:div.p-3.flex.w-1-3
            (cc/checkbox {:id         (str (:complaint/id complaint) " checkbox")
                          :label-text (tr [:case/add-to-case])
                          :checked    (contains? case-complaints complaint)
                          :on-change  #(>evt [::complaint-subs/update-new-case-complaints % complaint])
                          :disabled   (and (some? accepted-group)
                                           (not= accepted-group (:group/id complaint)))})])])]
     [:div.flex.flex-col.justify-start.-mx-2
      [:span.w-full.flex.content-center.justify-center.my-2.border-gray-500.border-t.border-solid]
      [:div.flex.w-1-2.px-1
       (cc/button {:size       :small
                   :class-name "w-full"
                   :on-click   #(>evt [::complaint-form/start-create-complaint location])}
                  (tr [:code-enforcement/create-complaint]))]
      [:span.w-full.flex.content-center.justify-center.my-2.border-gray-500.border-t.border-solid]
      [:div.flex.flex-row
       (when (<sub [::complaint-subs/write-auth-permit-type? :permit-type/CE])
         [create-case-button props :permit-type/CE case-complaints (tr [:code-enforcement/open-case-creation])])
       (when (<sub [::complaint-subs/write-auth-permit-type? :permit-type/PWO])
         [create-case-button props :permit-type/PWO case-complaints (tr [:work-orders/open-work-order-creation])])]]]))

(defn location-input [{:keys [new-comp-coords tr]}]
  (let [[x y]    new-comp-coords
        location {:location.center/x    x
                  :location.center/y    y
                  :address              (<sub [::create-v2/manual-address])
                  :location/description (:location/description (<sub [::create-v2/manual-input-values]))}]
    [map-common-info-box/right-side-box (util/mmap on-cancel-click tr)
     [:div.flex.flex-col.items-stretch
      [create-v2/manual-location-entry tr (util/mmap x y)]
      [:span.w-full.flex.content-center.justify-center.my-2.border-gray-500.border-t.border-solid]
      [:div.flex.flex-row
       [:div.flex.w-1-2
        (cc/button {:size       :small
                    :class-name "w-full"
                    :disabled   (str/blank? (:location/description (<sub [::create-v2/manual-input-values])))
                    :on-click   #(>evt [::complaint-subs/use-location location])}
                   (tr [:code-enforcement/use-location]))]]]]))


(defn- toggle-map-button [tr]
  (let [map-visible? (<sub [::complaint-subs/map-visible?])
        label        (tr [(if map-visible? :workspace/hide-map :workspace/show-map)])]
    (cc/button {:kind             :primary
                :size             :small
                :icon             (if map-visible? i/remove i/map)
                :class-name       (if map-visible? "bg-black" "")
                :icon-position    :right
                :icon-description label
                :on-click         #(>evt [::complaint-subs/toggle-map-visibility])}
               label)))


(defn map-and-property [{:keys [selected-group tr lang]}]
  (let [{:keys [geometry]
         :as   selected-property} (<sub [::complaint-subs/selected-property])
        location                  (<sub [::complaint-subs/location])
        new-comp-coords           (<sub [::complaint-subs/new-complaint-coordinates])
        map-center                (or (<sub [::complaint-subs/map-center])
                                      new-comp-coords
                                      (<sub [::municipality/center-coordinates (:group/id selected-group)]))
        total-search-count        (<sub [::complaint-search/result-total-count])
        geojson-results           (<sub [::complaint-subs/geojson-results])
        creating-new?             (<sub [::complaint-form/create-form-open?])
        point-search-loading?     (<sub [::map-common-util/point-search-loading?])
        complaint-id              (-> (<sub [::complaint-subs/complaint-in-view]) :complaint/id)
        layers                    (concat (<sub [::municipality/municipal-layers
                                                 (:group/id selected-group)
                                                 (ff/enabled? :feature-flag.id/public-works-location-enhancements)])
                                          (when geojson-results
                                            [{:type              "geojson-cluster"
                                              :id                complaint-subs/result-layer-id
                                              :title             (tr [:code-enforcement/complaints])
                                              :featureCollection geojson-results}]))]
    [:<>
     (when (ff/enabled? :feature-flag.id/complaints-main-menu-enhancements)
       [:div.mt-6.flex.w-full.justify-end
        [toggle-map-button tr]])
     (when (and (<sub [::complaint-subs/map-visible?]) map-center)
       [:div.flex.items-center.flex-wrap.lg:flex-nowrap
        [:div.flex.map-boundary.map-extended.bg-gray-400.rounded.overflow-hidden.h-full.w-full ;.mt-6
         {:class (when (or point-search-loading? selected-property complaint-id creating-new? new-comp-coords)
                   ["lg:w-2-3" "lg:mr-2"])
          :style {:height "500px"}}
         [workspace-map/workspace-map
          {:center             map-center
           :layers             layers
           :extended?          true
           :layerOpacity       0.7
           :primaryMapMarkers  [map-center]
           :setLayerIdOrder    #(>evt [::complaint-subs/set-layer-id-order %])
           :fitMapButton       {:layer complaint-subs/result-layer-id
                                :text  (tr [:dashboard-search/view-all]
                                           [total-search-count])}
           ;; No search on "moveend": the dashboard search is not bounded by the map extent
           ;; (see ::complaint-search/search), so re-running it on every map move only repeats
           ;; the exact same request. Recentering the map after selecting a property used to
           ;; fire a second, identical find-complaints call on top of the property search.
           :events             [{:eventType     "singleclick"
                                 :eventFunction #(>evt [::complaint-subs/map-click % selected-group])}]
           :zoom               15
           :propertyGeometries (if geometry
                                 {:primaryPropertyGeometry (property-model/geojson-feature geometry)}
                                 {})}]]
        (cond
          creating-new?
          [new-complaint-form (util/mmap tr lang selected-group selected-property location)]

          point-search-loading?
          [:div.flex.items-center.justify-center.h-full.w-full.lg:w-1-3.lg:ml-2
           [:div
            (cc/loading-spinner {:with-overlay false})]]

          complaint-id
          [complaint-view (util/mmap tr lang complaint-id selected-property)]

          (or selected-property location)
          [selected-property-view (util/mmap tr lang selected-group selected-property location)]

          (and new-comp-coords
               (ff/enabled? :feature-flag.id/complaints-wo-property))
          [location-input (util/mmap new-comp-coords tr)])])]))

(defn labelled-value [item kw tr]
  (when-let [value (get item kw)]
    [:div.mt-2
     [:span.font-bold.mr-2 (str (tr [kw]) ": ")]
     (tr [value])]))

(defn complaint-grid-item
  ([item show-severity? lang]
   (complaint-grid-item item show-severity? lang nil))
  ([item show-severity? lang on-click]
   (let [created-at  (:created item)
         modified-at (:modified item)
         tr          (<sub [::complaint-subs/complaint-tr (:permit-type item)])
         pt-label    (or (some-> item
                                 :complaint/permit-type-names
                                 (i18n-model/get-text-from-entities-or-map lang))
                         (some-> item :permit-type vector tr))]
     [:div.flex.flex-col.h-full.w-full.border-solid.border.border-ui-gray.p-4.rounded-md.cursor-pointer.hover:border-gray-700
      {:data-cy  "single-result"
       :on-click (or on-click
                     #(>evt [::complaint-subs/show-complaint-modal (:complaint/id item)]))}
      [:div
       [:div.font-bold.text-base (i18n-model/get-text-from-entities-or-map (:complaint/category-names item) lang)]
       (when pt-label
         [:div.text-base pt-label])]
      [:div.font-light
       [ui-updated/updated {:ts          created-at
                            :verb-tr-key :update-time-v2/created}]]
      (when (and modified-at (not= created-at modified-at))
        [:div.font-light
         [ui-updated/updated {:ts          modified-at
                              :verb-tr-key :update-time-v2/updated}]])
      [:div.mt-4 (or (:property/address item)
                     (:address/full-address item)
                     (some->> (get-in item [:location :coordinates])
                              reverse
                              (map #(futil/to-fixed % 5))
                              (str/join ", ")))]
      [:div (i18n-model/get-text-from-entities-or-map (:municipality/names item) lang)]
      (when show-severity?
        (labelled-value item :complaint/severity tr))
      (labelled-value item :domain/state tr)
      (when (:complaint/case-workspace-id item)
        [:div.flex.mt-auto.pt-4
         [:div.flex-1.text-right
          (go-to-case-button (:complaint/case-workspace-id item) tr
                             {:on-click #(.stopPropagation %)})]])])))


(defn load-more [tr]
  (let [current-count (<sub [::complaint-search/current-count])
        total-count   (<sub [::complaint-search/result-total-count])]
    (when (> total-count current-count)
      [:div.bx--row>div.bx--col-xs-12.flex.justify-center
       [:div.cursor-pointer.p-4.flex.flex-col.items-center
        {:on-click #(>evt [::complaint-search/load-more])}
        (cc/icon {:icon        i/refresh
                  :class-name  "mb-4"
                  :description (tr [:dashboard-search/load-more] [(- total-count current-count)])})
        [:span.semibold (tr [:dashboard-search/load-more] [(- total-count current-count)])]]])))


(defn complaints-list [{:keys [tr lang]}]
  (let [results        (<sub [::complaint-search/search-results])
        items-to-show  (<sub [::complaint-search/current-count])
        show-severity? (and (ff/enabled? :feature-flag.id/complaints-priority)
                            (some :complaint/severity results))]
    [:div {:data-cy "results-section"}
     [:div.flex.py-4.justify-between.items-center
      [:h3.mb-0
       (str (tr [:code-enforcement/results])
            (when (seq results) (str " (" (count results) ")")))]
      [:div
       [ui-select/select {:id           "sort-complaints"
                          :allow-empty? false
                          :select-text  (tr [:code-enforcement/sort])
                          :value        (<sub [::complaint-search/sort-condition])
                          :values       (cond-> [:search-sorting/created-asc
                                                 :search-sorting/modified-asc
                                                 :search-sorting/modified-desc]
                                          show-severity?
                                          (conj :search-sorting/severity))
                          :on-change    #(>evt [::complaint-search/set-sort-condition %])
                          :val->str     #(tr [%])}]]]
     (if (seq results)
       [:div
        [:div.grid.gap-4.grid-cols-2.xl:grid-cols-4
         (for-frag [item (take items-to-show results)]
           [complaint-grid-item item show-severity? lang])]
        [load-more tr]]
       [:div (tr [:code-enforcement/no-complaints])])]))


(defn municipality-select
  [{:keys [id tr lang groups selected-group on-change hide-label?]}]
  (let [group->str #(-> % :municipality/names (i18n-model/get-text-from-entities-or-map lang))]
    (if (<sub [::ff/enabled? :feature-flag.id/combobox-in-complaint-dashboard])
      [ui-combo/combo-box {:id          id
                           :tr          tr
                           :on-change   on-change
                           :items       groups
                           :item->id    :municipality/number
                           :value       selected-group
                           :placeholder (tr [:code-enforcement/select-municipality])
                           :label-text  (tr [:code-enforcement/select-municipality])
                           :hide-label  (boolean hide-label?)
                           :item->str   group->str}]
      [ui-select/select {:allow-empty? false
                         :class-name   "full-width-select"
                         :label-text   (tr [:code-enforcement/select-municipality])
                         :hide-label   (boolean hide-label?)
                         :id           id
                         :values       groups
                         :val->str     group->str
                         :on-change    on-change
                         :value        selected-group}])))


(defn complaints-management []
  (let [groups         (<sub [::complaint-subs/code-enforcement-groups])
        selected-group (<sub [::complaint-subs/selected-group])
        loading?       (<sub [::complaint-subs/loading?])
        lang           (<sub [:language])
        tr             (<sub [::complaint-subs/property-tr])
        multi-group?   (du/at-least-two? groups)]
    [:section
     (cond
       loading?
       [:div.flex.items-center.justify-center.mb-6.mt-6
        (cc/loading-spinner {:with-overlay false})]

       selected-group
       [:div
        [:div.mb-3.-mt-3
         [:div.flex.flex-wrap.-mx-2
          [:div.w-full.px-2.mt-3 {:class [(when multi-group?
                                            "md:w-2-3 lg:w-3-4")]}
           [gis-search/address-search
            {:tr                 tr
             :show-existing?     false
             :domain-group-id    (:group/id selected-group)
             :municipalities     [(:municipality/number selected-group)]
             :on-select-address  #(>evt [::complaint-subs/select-property %])
             :on-select-location #(>evt [::complaint-subs/select-property %])}]]
          (when multi-group?
            [:div.w-full.md:w-1-3.lg:w-1-4.px-2.mt-3
             [municipality-select {:id             "complaint-management-muni-selection"
                                   :tr             tr
                                   :lang           lang
                                   :groups         groups
                                   :selected-group selected-group
                                   :on-change      #(>evt [::complaint-subs/select-group %])
                                   :hide-label?    true}]])]]
        [complaint-search/filter-controls tr]]

       :else
       [:div.mt-6.mb-6.bold.text-xl.text-center
        (tr [:code-enforcement/no-access])])
     [map-and-property (util/mmap selected-group tr lang)]
     [complaints-list (util/mmap selected-group tr lang)]
     [complaint-detail-view/complaint-modal-view (util/mmap {:allow-edit? true} tr lang loading?)]]))


(defn view [_match]
  (let [tr (<sub [::complaint-subs/property-tr])]
    [:div.cloudpermit-page
     [:div.bx--row.page-heading.justify-between
      [:h1.bx--col-xs-12 (tr [:view/code-enforcement-complaints])]]
     [ui/instructions (util/mmap {:paragraphs [[:complaint/instruction-how-to-use-title
                                                :complaint/instruction-how-to-use-text]
                                               [:complaint/instruction-how-to-complain-title
                                                :complaint/instruction-how-to-complain-text]]
                                  :id         "complaint-view-instructions"}
                                 tr)]
     [complaints-management]
     (when (<sub [::new-case-view/create-modal-open?])
       [new-case-view/create-case-modal])
     (when (<sub [::new-case-view/optional-params-modal-open?])
       [new-case-view/optional-params-modal])]))


(def route
  {:name        :view/code-enforcement-complaints
   :view        view
   :parameters  {:query (st/optional-keys {:complaint-ref s/Str
                                           :modal         s/Any
                                           :group-id      s/Int})}
   :controllers [{:start (fn []
                           (>evt [::complaint-subs/init]))
                  :stop  (fn [_]
                           (>evt [::complaint-subs/leave])
                           ; Removed from the leave event to prevent circular dependency.
                           (>evt [::new-case-view/clear-state]))}
                 {:parameters {:query [:complaint-ref :modal :group-id]}
                  :start      (fn [{{:keys [complaint-ref modal group-id]} :query}]
                                (when complaint-ref
                                  (if modal
                                    (>evt [::complaint-subs/show-complaint-modal complaint-ref])
                                    (>evt [::complaint-subs/open-complaint-view complaint-ref])))
                                (when group-id
                                  (>evt [::complaint-subs/set-pre-selected-group-id group-id])))}]})
